import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SimpleHeaderImageItemBlockConfig } from '@front-platform/content-builder';
import { simpleHeaderImageItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface SimpleHeaderImageItemBlockRuntimeConfig {}

export type SimpleHeaderImageItemBlockConfigInput = Partial<
  Omit<SimpleHeaderImageItemBlockConfig, keyof SimpleHeaderImageItemBlockRuntimeConfig> &
    SimpleHeaderImageItemBlockRuntimeConfig
>;
export type SimpleHeaderImageItemBlockResolvedConfig = Omit<
  SimpleHeaderImageItemBlockConfig,
  keyof SimpleHeaderImageItemBlockRuntimeConfig
> &
  Partial<SimpleHeaderImageItemBlockRuntimeConfig>;
export interface SimpleHeaderImageItemBlockContract extends ConfigComponentContract<
  SimpleHeaderImageItemBlockConfigInput,
  SimpleHeaderImageItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-simple-header-image-item-block',
  templateUrl: './simple-header-image-item-block.component.html',
  styles: [],
  standalone: false,
})
export class SimpleHeaderImageItemBlockComponent implements SimpleHeaderImageItemBlockContract {
  readonly config = input<SimpleHeaderImageItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SimpleHeaderImageItemBlockConfig,
    SimpleHeaderImageItemBlockRuntimeConfig
  >(simpleHeaderImageItemBlockResolveConfig, () => ({ config: this.config() }));
  get image(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  get linkTarget(): string {
    return this.resolvedConfig()['link_target'] as unknown as string;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SimpleHeaderImageItemBlockComponent, {
  'keyAliases': {},
});
